// ============================================================================
// Watch Feed API
// - fetchWatchFeed: algo-api service (Bearer token + cookie auth, via algoRequest)
// - startWatch / getWatchReward: main Blidz API (CSRF + cookie auth via apiClient)
// ============================================================================

import { algoRequest } from "~/api/algo-client";
import { apiClient } from "~/api/client";

// ============================================================================
// Types
// ============================================================================

export interface WatchFeedRequest {
  tab?: "default" | "drama";
  count?: number;
  channel?: string;
}

export interface WatchFeedItem {
  feedItemId: string;
  type?: string;
  dealId?: string;
  title?: string;
  thumbnail?: string;
  videoUrl?: string;
  viewCount?: number;
  likeCount?: number;
  dramaSeries?: {
    seriesId: string;
  };
}

export interface WatchFeedResponse {
  feedItems: WatchFeedItem[];
}

// ============================================================================
// Algo API — fetch feed
// ============================================================================

export async function fetchWatchFeed(
  readToken: () => string | null,
  params: WatchFeedRequest = {}
): Promise<WatchFeedResponse> {
  return algoRequest<WatchFeedResponse>(
    "/api/watch/feed",
    { tab: "default", count: 10, channel: "{}", ...params },
    readToken
  );
}

// ============================================================================
// Main Blidz API — start watch (called when video playback starts)
// ============================================================================

export async function startWatch(feedItemId: string): Promise<void> {
  await apiClient.makeAuthenticatedRequest("/watch_feed/start_watch", {
    params: { feedItemId },
  });
}

// ============================================================================
// Main Blidz API — get reward (called when user has watched >= 3 seconds)
// ============================================================================

export interface GetRewardResponse {
  cashAmount?: number;
  spinAmount?: number;
  fincoinAmount?: number;
  totalFincoinAmount?: number;
  totalAmount?: number;
  totalVideoCountForSpin?: number;
  videoCountLeftForSpin?: number;
}

export async function getWatchReward(feedItemId: string): Promise<GetRewardResponse> {
  return apiClient.makeAuthenticatedRequest<GetRewardResponse>("/watch_feed/get_reward", {
    params: { feedItemId },
  });
}
